import { Editor } from 'slate'
import { ElementWithType } from '../../../../../../utils/types'

export const disableOnCodeChild = ({ editor }) => {
  const [code] = Editor.nodes(editor, {
    match: (n: ElementWithType) => n.type === 'code',
    mode: 'lowest'
  })
  return Boolean(code)
}
